import PlacementDetails from "./Container"

export default PlacementDetails
